import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../lib/config';

export interface AuthCapabilities {
  emailVerificationRequired: boolean;
  passwordResetEnabled: boolean;
  invitationEmailEnabled: boolean;
  googleWorkspaceSignInEnabled: boolean;
}

export function useAuthCapabilities() {
  const [data, setData] = useState<AuthCapabilities | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/auth-capabilities`, { credentials: 'include' })
      .then(async res => {
        if (!res.ok) throw new Error('Failed to load auth capabilities');
        return (await res.json()) as AuthCapabilities;
      })
      .then(body => {
        if (!cancelled) setData(body);
      })
      .catch(() => {
        if (!cancelled) {
          setData({
            emailVerificationRequired: false,
            passwordResetEnabled: false,
            invitationEmailEnabled: false,
            googleWorkspaceSignInEnabled: false,
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return data;
}
